import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/feature/JsonLd';
import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

const siteUrl = typeof import.meta !== 'undefined' && import.meta.env.VITE_SITE_URL ? import.meta.env.VITE_SITE_URL : 'https://yoybuyfinds.mom';

const articleSchema = {
  '@context': 'https://schema.org',
  '@type': 'Article',
  'headline': 'YOYBUY Spreadsheet — Что это и как работает в 2026',
  'description': 'Полное руководство по использованию YOYBUY Spreadsheet. Узнайте, что такое YOYBUY подборки, как они работают, сравнение с Kakobuy и Superbuy, и как начать покупать умнее уже сегодня.',
  'author': {
    '@type': 'Organization',
    'name': 'YOYBUY Finds',
  },
  'publisher': {
    '@type': 'Organization',
    'name': 'YOYBUY Finds',
    'logo': {
      '@type': 'ImageObject',
      'url': 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/67a09e300463e31c534fcef7be7473f7.jpeg',
    },
  },
  'datePublished': '2026-07-01',
  'dateModified': '2026-07-05',
  'mainEntityOfPage': {
    '@type': 'WebPage',
    '@id': siteUrl + '/article/yoybuy-spreadsheet-guide',
  },
  'inLanguage': 'ru',
};

const tableData = [
  { product: 'Sneakers Classic', price: '$30', rating: '⭐⭐⭐⭐⭐', quality: 'Высокое' },
  { product: 'Oversized Hoodie', price: '$25', rating: '⭐⭐⭐⭐', quality: 'Среднее' },
  { product: 'Tech Gadget Pro', price: '$40', rating: '⭐⭐⭐⭐⭐', quality: 'Высокое' },
  { product: 'T-Shirt Premium', price: '$12', rating: '⭐⭐⭐⭐', quality: 'Хорошее' },
  { product: 'Leather Belt', price: '$18', rating: '⭐⭐⭐⭐⭐', quality: 'Высокое' },
  { product: 'Canvas Tote Bag', price: '$22', rating: '⭐⭐⭐⭐', quality: 'Хорошее' },
];

const comparisonData = [
  { feature: 'Качество товаров', yoybuy: 'Высокое', kakobuy: 'Среднее', superbuy: 'Высокое' },
  { feature: 'Скорость доставки', yoybuy: '10-15 дней', kakobuy: '12-18 дней', superbuy: '8-12 дней' },
  { feature: 'Проверка качества', yoybuy: 'Есть', kakobuy: 'Ограниченная', superbuy: 'Есть' },
  { feature: 'Spreadsheet подборки', yoybuy: 'Да', kakobuy: 'Нет', superbuy: 'Частично' },
  { feature: 'Поддержка клиентов', yoybuy: '24/7', kakobuy: 'Рабочие часы', superbuy: '24/7' },
];

export default function ArticlePage() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={articleSchema} />
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative pt-28 pb-16 bg-background-100 overflow-hidden">
          <div className="max-w-6xl mx-auto px-4 md:px-6 flex flex-col lg:flex-row items-start gap-10 lg:gap-0">
            <div className="w-full lg:w-3/5">
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-900 leading-tight">
                YOYBUY Spreadsheet
                <br />
                Что это и как
                <br />
                <span className="text-primary-500">работает в 2026</span>
              </h1>
            </div>
            <div className="w-full lg:w-2/5 lg:pl-10 lg:pt-4">
              <div className="flex items-center gap-4 text-sm text-foreground-500 mb-6">
                <span>Обновлено: Июль 2026</span>
                <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                <span>Время чтения: 8 мин</span>
              </div>
              <div className="flex flex-col sm:flex-row gap-3">
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="px-5 py-3 rounded-full border-2 border-foreground-800 text-foreground-800 text-sm font-medium hover:bg-foreground-800 hover:text-background-50 transition-all duration-300 whitespace-nowrap text-center cursor-pointer"
                >
                  yoybuy sheet
                </a>
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="px-5 py-3 rounded-full border-2 border-primary-500 text-primary-600 text-sm font-medium hover:bg-primary-500 hover:text-background-50 transition-all duration-300 whitespace-nowrap text-center cursor-pointer"
                >
                  buy it now
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Article Body */}
        <section className="py-16 md:py-20 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <article className="prose-custom">
              <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 mb-12">
                <div className="w-full lg:w-1/3">
                  <span className="inline-flex px-4 py-1.5 rounded-full border border-foreground-200 text-xs text-foreground-600 mb-6">
                    SEO
                  </span>
                  <div className="rounded-2xl overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Minimal%20laptop%20with%20spreadsheet%20on%20screen%20surrounded%20by%20fashion%20items%20on%20cream%20desk%2C%20warm%20natural%20light%2C%20clean%20editorial%20photography%2C%20European%20aesthetic%2C%20neutral%20soft%20tones%2C%20elevated%20composition&width=500&height=650&seq=article-hero-img&orientation=portrait"
                      alt="YOYBUY Spreadsheet полное руководство"
                      className="w-full h-full object-cover"
                      title="YOYBUY Spreadsheet руководство 2026"
                    />
                  </div>
                </div>

                <div className="w-full lg:w-2/3">
                  <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900 mb-5">
                    Что такое YOYBUY Spreadsheet?
                  </h2>
                  <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5">
                    <strong>YOYBUY Spreadsheet</strong> — это специально подготовленные таблицы с подборками лучших товаров из Китая. В отличие от хаотичного поиска в интернете,{' '}
                    <Link to="/" className="text-primary-600 hover:text-primary-500 underline">yoybuy sheet</Link> подборки содержат только проверенные позиции с указанием цен, размеров, оценок качества и прямых ссылок для покупки через агента YOYBUY.
                  </p>
                  <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5">
                    Идея проста: вместо того чтобы тратить часы на поиск надёжных продавцов и сравнение товаров, вы получаете готовый curated список. Каждая позиция в <strong>YOYBUY spreadsheet</strong> проверена вручную — мы смотрим на качество материалов, отзывы реальных покупателей и репутацию продавца.
                  </p>
                  <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                    В 2026 году <strong>YOYBUY</strong> стал одним из самых популярных агентов для покупок из Китая. А готовые spreadsheet таблицы позволяют новичкам начать покупать умнее буквально за несколько минут.
                  </p>
                </div>
              </div>

              {/* Comparison Table */}
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-6">
                Сравнение агентов: YOYBUY, Kakobuy и Superbuy
              </h2>
              <div className="overflow-x-auto mb-12">
                <table className="w-full text-sm border-collapse">
                  <thead>
                    <tr className="bg-foreground-950 text-background-50">
                      <th className="px-4 py-3 text-left rounded-tl-lg">Характеристика</th>
                      <th className="px-4 py-3 text-center">YOYBUY</th>
                      <th className="px-4 py-3 text-center">Kakobuy</th>
                      <th className="px-4 py-3 text-center rounded-tr-lg">Superbuy</th>
                    </tr>
                  </thead>
                  <tbody>
                    {comparisonData.map((row, i) => (
                      <tr key={row.feature} className={i % 2 === 0 ? 'bg-background-100' : 'bg-background-50'}>
                        <td className="px-4 py-3 font-medium text-foreground-800">{row.feature}</td>
                        <td className="px-4 py-3 text-center text-primary-600 font-semibold">{row.yoybuy}</td>
                        <td className="px-4 py-3 text-center text-foreground-600">{row.kakobuy}</td>
                        <td className="px-4 py-3 text-center text-foreground-600">{row.superbuy}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Benefits */}
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-6">
                Преимущества использования YOYBUY Spreadsheet
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-12">
                <div className="p-5 rounded-lg bg-accent-50 border border-accent-200">
                  <h3 className="text-sm font-semibold text-foreground-900 mb-2">Экономия времени</h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">
                    Готовые подборки YOYBUY spreadsheet экономят до 5 часов поиска на каждую категорию товаров. Просто открывайте таблицу и выбирайте.
                  </p>
                </div>
                <div className="p-5 rounded-lg bg-primary-50 border border-primary-200">
                  <h3 className="text-sm font-semibold text-foreground-900 mb-2">Проверенное качество</h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">
                    Все позиции в наших YOYBUY spreadsheet подборках проходят ручную проверку — мы заказываем товары сами и оцениваем реальное качество.
                  </p>
                </div>
                <div className="p-5 rounded-lg bg-secondary-100 border border-secondary-200">
                  <h3 className="text-sm font-semibold text-foreground-900 mb-2">Сравнение цен</h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">
                    Мы сравниваем цены между разными продавцами и агентами. Наши <strong>spreadsheet таблицы</strong> помогают экономить до 30% от розничной цены.
                  </p>
                </div>
                <div className="p-5 rounded-lg bg-accent-50 border border-accent-200">
                  <h3 className="text-sm font-semibold text-foreground-900 mb-2">Прямые ссылки</h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">
                    Каждый товар в <strong>YOYBUY spreadsheet</strong> идёт с прямой ссылкой на покупку — никакого копирования и поиска вручную.
                  </p>
                </div>
              </div>

              {/* Product Table */}
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-6">
                Лучшие YOYBUY Finds — Июль 2026
              </h2>
              <div className="overflow-x-auto mb-12">
                <table className="w-full text-sm border-collapse">
                  <thead>
                    <tr className="bg-foreground-950 text-background-50">
                      <th className="px-4 py-3 text-left rounded-tl-lg">Товар</th>
                      <th className="px-4 py-3 text-center">Цена</th>
                      <th className="px-4 py-3 text-center">Рейтинг</th>
                      <th className="px-4 py-3 text-center rounded-tr-lg">Качество</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.map((row, i) => (
                      <tr key={row.product} className={i % 2 === 0 ? 'bg-background-100' : 'bg-background-50'}>
                        <td className="px-4 py-3 font-medium text-foreground-800">{row.product}</td>
                        <td className="px-4 py-3 text-center text-primary-600 font-semibold">{row.price}</td>
                        <td className="px-4 py-3 text-center">{row.rating}</td>
                        <td className="px-4 py-3 text-center text-foreground-600">{row.quality}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* How to Use */}
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-6">
                Как использовать YOYBUY Spreadsheet: пошаговая инструкция
              </h2>
              <div className="space-y-5 mb-12">
                {[
                  { step: '1', title: 'Откройте таблицу', desc: 'Перейдите в раздел YOYBUY spreadsheet на нашем сайте и выберите интересующую категорию товаров.' },
                  { step: '2', title: 'Выберите товар', desc: 'Просмотрите подборку, сравните цены и рейтинги. В таблице есть вся необходимая информация для принятия решения.' },
                  { step: '3', title: 'Перейдите по ссылке', desc: 'Нажмите на прямую ссылку товара — она откроется в YOYBUY агенте, где вы сможете оформить заказ.' },
                  { step: '4', title: 'Купите через агента', desc: 'Оформите покупку через YOYBUY. Агент проверит товар, упакует и отправит его вам.' },
                ].map((item) => (
                  <div key={item.step} className="flex gap-4 p-5 rounded-lg bg-background-100">
                    <span className="flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-background-50 font-semibold text-sm">
                      {item.step}
                    </span>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900 mb-1">{item.title}</h3>
                      <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/* FAQ */}
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-6">
                Часто задаваемые вопросы о YOYBUY Spreadsheet
              </h2>

              <div className="space-y-4 mb-12">
                <div className="p-5 rounded-lg bg-background-100">
                  <h3 className="text-sm font-semibold text-foreground-900 mb-2">
                    Безопасно ли покупать через YOYBUY spreadsheet?
                  </h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">
                    Да, абсолютно. Все ссылки в наших <Link to="/" className="text-primary-600 hover:text-primary-500 underline">yoybuy finds</Link> подборках ведут на официальный сайт агента YOYBUY, который использует защищённые платежи и проверку продавцов.
                  </p>
                </div>
                <div className="p-5 rounded-lg bg-background-100">
                  <h3 className="text-sm font-semibold text-foreground-900 mb-2">
                    Как часто обновляются spreadsheet подборки?
                  </h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">
                    <strong>YOYBUY spreadsheet</strong> обновляется каждую неделю. Мы удаляем неактуальные позиции и добавляем новые находки, чтобы вы всегда получали свежие предложения.
                  </p>
                </div>
                <div className="p-5 rounded-lg bg-background-100">
                  <h3 className="text-sm font-semibold text-foreground-900 mb-2">
                    Как отличить YOYBUY от AliExpress?
                  </h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">
                    В отличие от AliExpress, <strong>YOYBUY</strong> — это агент, который проверяет качество товара перед отправкой. Вы получаете дополнительный уровень защиты и уверенность в покупке. Наши <strong>spreadsheet находки</strong> содержат только проверенные товары, а не случайные предложения.
                  </p>
                </div>
              </div>

              {/* CTA */}
              <div className="text-center py-8 px-6 rounded-2xl bg-primary-50 border border-primary-200">
                <h3 className="text-lg font-heading font-bold text-foreground-900 mb-3">
                  Готовы начать покупать умнее?
                </h3>
                <p className="text-sm text-foreground-600 mb-6 max-w-md mx-auto">
                  Откройте наши <strong>YOYBUY spreadsheet подборки</strong> и найдите лучшие товары из Китая уже сегодня.
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                  <a
                    href={mainSiteUrl}
                    target="_blank"
                    rel="noopener nofollow"
                    className="px-6 py-3 rounded-full bg-foreground-900 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
                  >
                    Открыть YOYBUY Spreadsheet
                  </a>
                  <Link
                    to="/"
                    className="px-6 py-3 rounded-full border border-foreground-300 text-foreground-700 text-sm font-medium hover:bg-foreground-50 transition-all duration-300 whitespace-nowrap cursor-pointer"
                  >
                    ← На главную
                  </Link>
                </div>
              </div>
            </article>
          </div>
        </section>

        {/* Bottom CTA */}
        <section className="relative py-20 md:py-28 overflow-hidden">
          <div className="absolute inset-0 z-0">
            <img
              src="https://readdy.ai/api/search-image?query=Soft%20warm%20minimal%20flat%20lay%20of%20fashion%20and%20accessories%20on%20cream%20surface%2C%20peaceful%20editorial%20photography%2C%20neutral%20aesthetic%2C%20airy%20composition%2C%20no%20people&width=1600&height=700&seq=article-cta-bg&orientation=landscape"
              alt="YOYBUY Finds"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-foreground-950/45"></div>
          </div>
          <div className="relative z-10 text-center px-4 md:px-6">
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 tracking-wider mb-6">
              КУПИТЬ ЧЕРЕЗ YOYBUY
            </h2>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-3 mt-4 px-8 py-4 rounded-full bg-foreground-950 text-background-50 text-sm font-semibold hover:bg-foreground-900 transition-all duration-300 whitespace-nowrap cursor-pointer group"
            >
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-shopping-bag-3-line"></i>
              </span>
              ПЕРЕЙТИ В МАГАЗИН
              <span className="w-5 h-5 flex items-center justify-center group-hover:translate-x-0.5 transition-transform">
                <i className="ri-arrow-right-up-line"></i>
              </span>
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}